<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon" [arianeList]="arianeList"></app-ariane-nav>

<mat-divider class="my-3"></mat-divider>

<div class="div-conteneur">
  <app-data-table-optimized
    #avisTable
    [getData]="getDemandesAvis"
    [displayedColumns]="demandesDisplayedColumns"
    [cellStyleCss]="demandesCellStyleCss"
    [headerStyleCss]="demandesHeaderStyleCss"
    [selectable]="false"
    [validable]="false"
    [refusable]="false"
    [advicable]="true"
    [hasView]="false"
    (getAdviceEvent)="avisDemande($event)"
  >
  </app-data-table-optimized>
</div>
